
import { getOrderServiceProgressList } from '@/api/orderService';
import { getProgressList } from '@/api/order';
import { UserModule } from '@/store/modules/user';
import DialogImgLarge from '@/components/ImgLarge/index.vue';
import DilogSetDepartment from '@/views/staff/components/setDepartment.vue'
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import BenzAMRRecorder from 'benz-amr-recorder';
import { checkPermissionUseAndCompany } from '@/utils/permission';
import { Type } from '@/types/permissionType';
import { addCustomer } from '@/api/customer';
import DialogDeviceRecord from "@/views/device/components/DeviceRecord.vue";

@Component({
  name: 'OrderInfo',
  components: {
    DialogImgLarge,
    DilogSetDepartment,
    DialogDeviceRecord
  },
  filters: {
    getAppointmentime(val: any) {
      if (val && val.length > 0) {
        if ('appointment_time' in val[0]) {
          return val[0].appointment_time;
        } else {
          return '暂无';
        }
      } else {
        return '暂无';
      }
    },
  }
})
export default class extends Vue {
  @Prop({
    type: String,
    default: 'infor'
  })tabName!:any;

  @Prop({
    type: Object,
    default: () => ({
      order: {},
      order_service: {}
    })
  })orderDetail!:any;
  @Prop({
    type: Number,
    default: 11
  })orderType!:any;

  private orderProgressData:any = {};
  private activeLeft:any = 'infor';
  private vipLev=0;
  private isCustomerModule=false;
  private isShowDeviceHistry: boolean=false;

   @Watch('orderDetail', {
     deep: true,
     immediate: true
   })
  orderDetailChangeProps() {
    if (this.activeLeft === 'schedule') {
      this.getProgressList()
    }
  }
  get orderCheckProgressObj(){
    if(this.orderDetail.order_service.order_check_progress && this.orderDetail.order_service.order_check_progress.length>0 ){
      const v = this.orderDetail.order_service.order_check_progress[this.orderDetail.order_service.order_check_progress.length-1];
      let styleStr =  "";
      if(parseInt(v.state) === 71){
        styleStr = "el-icon-success font-green";
      }else if(parseInt(v.state) === 51){
        styleStr = "font-green";
      }else if(v.state==91){
        styleStr = "el-icon-error font-red";
      }
      return styleStr;
    }else{
      return "";
    }
  }
  get orderCheckProgressTtile(){
    if(this.orderDetail.order_service.order_check_progress && this.orderDetail.order_service.order_check_progress.length>0 ){
      //获取数组order_check_progress最后一个元素
      const v = this.orderDetail.order_service.order_check_progress[this.orderDetail.order_service.order_check_progress.length-1];
      let stateStr = "待审核";
      const state = parseInt(v.state);
      switch(state){
        case 71:
          stateStr = "审核通过";
          break;
        case 51:
          stateStr = "审核中";
          break;
        case 91:
          stateStr = "审核驳回";
          break;
        default:
          stateStr = "待审核";
          break;
      }
      return stateStr;
    }else{
      return "";
    }

  }
   created() {
     // 李闯说角色的
     this.isCustomerModule = checkPermissionUseAndCompany(UserModule.getCompanyId, Type.CUSTOMER_COMPANY);
     this.isShowDeviceHistry = checkPermissionUseAndCompany(UserModule.getCompanyId, Type.DeviceHistry);
     this.activeLeft = this.tabName;
     if (UserModule.getCompany && UserModule.getCompany.vip_level) {
       this.vipLev = parseInt(UserModule.getCompany.vip_level.substr(0, 1));
     }
     if (this.activeLeft === 'schedule') {
       this.getProgressList()
     }
   }
   private handleCustomerClick(tab: any, event: any) {
     switch (tab.name) {
       case 'schedule':
         this.getProgressList()
         break;
     }
   }
   private customerRecordHandle() {
     let cus:any = {
       company_id: this.orderDetail.order.customer_company_id,
       user_id: this.orderDetail.order.customer_user_id,
       customer_type: this.orderDetail.order.customer_type,
       create_user_id:  this.orderDetail.order.create_user_id,
     }
     let routeData = this.$router.resolve({
       path: '/Record/list',
       query: cus
     });
     window.open(routeData.href);
   }
   private jionCompany() {
     this.setDepartmentVisible = true;
   }
  private setDepartmentVisible = false;

  departmentClose(val: boolean) {
    this.setDepartmentVisible = val;
  }
  setDeptSuccess(val: boolean) {
    this.setDepartmentVisible = val;
    this.$emit('referesh', '')
  }
  private voiceHandle(val: any, index: number) {
    let _this = this;
    let amr = new BenzAMRRecorder();

    for (let i = 0; i < val.length; i++) {
      if (i === index) {
        val[i].isPlaying = true;
      }
      val[i].isPlaying = false;
    }

    amr.initWithUrl(val[index].full_path).then(function() {
      val[index].isPlaying = true;
      amr.play();
      _this.$set(val, index, val[index]);
    });

    amr.onEnded(function() {
      amr.stop();
      val[index].isPlaying = false;
      _this.$set(val, index, val[index]);
    });
  }
  private imgLargeHandle(val: [], index: number, type:number) {
    let arr = [];
    if (type === 2) {
      let h: any = {};
      h.media_type = type;
      h.video_url = val;
      arr.push(h);
    } else {
      for (let i = 0; i < val.length; i++) {
        arr.push(val[i]);
      }
    }
    if (type === 10) {
      val.forEach((element:any) => {
        element.img_url = element.full_path;
      });
    }
    let enlargedData = {
      isShow: true,
      imgList: arr,
      initNum: index
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }
  private clickDocument(val: any) {
    const url = val.full_path;
    const filename = val.original_name;
    let arr = ['pdf', 'html'];
    let nameArr = filename.split('.');
    if (arr.includes(nameArr[1])) {
      window.open(url);
    } else {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.responseType = 'blob';
      xhr.onload = function() {
        if (this.status === 200) {
          const blob = new Blob([this.response]);
          const blobUrl = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = blobUrl;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(blobUrl);
        }
      };
      xhr.send();
    }
  }
  private isShowDevice = false
  private toggleDeviceShow() {
    this.isShowDevice = !this.isShowDevice
  }
  // 设备履历
  private dialogDeviceRecordVisible = false;
  private rowData: any = "";
  private deviceRecordHandle(val: any) {
    this.rowData = val;
    this.dialogDeviceRecordVisible = true;
  }
  closeRecordHandle(value: boolean) {
    this.dialogDeviceRecordVisible = value;
  }
  private getProgressList() {
    let p: any = {};
    p.user_id = UserModule.getUserId;
    p.company_id = UserModule.getCompanyId;
    p.order_service_id = this.orderDetail.order_service.id;
    if (this.orderDetail.order.id) {
      p.order_id = this.orderDetail.order.id;
    }
    p.user_name = UserModule.getUserName;
    if(21==this.orderType){
      getProgressList(p)
      .then((res) => {
        const data = res.data;
        if (data !== null) {
          this.orderProgressData = data;
        } else {
          this.orderProgressData = {};
        }
      })
      .catch((err) => {
        let msg = err.msg;
        this.orderProgressData = {};
      });
    }else{
      getOrderServiceProgressList(p)
      .then((res) => {
        const data = res.data;
        if (data !== null) {
          this.orderProgressData = data;
        } else {
          this.orderProgressData = {};
        }
      })
      .catch((err) => {
        let msg = err.msg;
        this.orderProgressData = {};
      });
    }
  
  }
  private addUserToCustomer(val:any) {
    if (parseInt(val.order.customer_type) === 1) {
      let pamars:any = {
        company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
        user_id: UserModule.getUserId };
      pamars.add_type = 2;
      pamars.type = 1;
      pamars.is_order = 1;
      pamars.customer_company_id = val.order.customer_company_id;
      addCustomer(pamars).then((res:any) => {
        this.showSecussMsg(res.msg);
        this.$emit('referesh', '')
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
      return;
    }
    this.$router.push({
      path: '/Customer/toCustomer',
      query: { 'orderDetail': JSON.stringify(val) }
    });
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
